/* import __COLOCATED_TEMPLATE__ from './seat-selector.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type QuoteService from 'embercom/services/quote-service';
import { ModalTypes } from './subscription-builder';
import { action } from '@ember/object';

interface Args {
  header: string;
  loading: boolean;
  hasOverageSeats: boolean;
  overageSeatCount: number;
  fullPrice: number;
  seatNumber: number;
  overageSavings: number;
  minimumSeatNumber: number;
  maximumCopilotSeats?: number;
  priceTranslationString: string;
  isDisabled: boolean;
  isDowngradeScheduled: boolean;
  updateSeatNumber: (seatNumber: number) => void;
  moveMonthlyOverageSeatsToAnnual: () => void;
  showModal: (modalType: ModalTypes) => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
  Blocks: {
    liteSeatsConversionBanner?: [];
  };
}

export default class SeatSelector extends Component<Signature> {
  @service declare intl: any;
  @service declare quoteService: QuoteService;
  @service declare appService: AppService;

  get overagePrice() {
    return this.args.fullPrice * this.args.overageSeatCount;
  }

  @action
  updateSeatNumber(value: number) {
    let seatValue = Number(value);
    let seatNumber: number;
    if (this.args.isDisabled) {
      seatNumber = this.args.seatNumber;
      if (this.args.isDowngradeScheduled) {
        this.args.showModal(ModalTypes.CannotEditWithScheduledDowngrade);
      }
    } else if (seatValue < this.args.minimumSeatNumber) {
      seatNumber = this.args.minimumSeatNumber;
    } else if (this.args.maximumCopilotSeats && seatValue > this.args.maximumCopilotSeats) {
      this.args.showModal(ModalTypes.AddingTooManyCopilotSeats);
      seatNumber = this.args.maximumCopilotSeats;
    } else if (seatValue > 100) {
      seatNumber = 100;
    } else {
      seatNumber = seatValue;
    }
    this.args.updateSeatNumber(seatNumber);
  }

  @action
  handleClick() {
    if (this.args.isDowngradeScheduled) {
      this.args.showModal(ModalTypes.CannotEditWithScheduledDowngrade);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::AnnualManageSubscription::SeatSelector': typeof SeatSelector;
  }
}
